import { action, computed, makeObservable, observable } from "mobx";
import { DefaultRequestStatus, RequestStatus } from "../services/services/requestStatus";

export interface DocumentStore {
    files: Map<FilesKeys, File>;
    getFileBlob: (fileKey: FilesKeys) => string;
    getFileName: (fileKey: FilesKeys) => string;
    getFileRequestStatus: (fileKey: FilesKeys) => RequestStatus;
    resetFilesMap: () => void;
    savePdf: (fileKey: FilesKeys, res: any, fileName?: string) => void;
}

interface File {
    fileName: string;
    fileBlob: string;
    requestStatus: RequestStatus;
}

export enum FilesKeys {
    generalTermsAndConditions = "generalTermsAndConditions",
    productCard = "productCard",
    policy = "policy",
    informationForm = "informationForm",
    paymentForm = "paymentForm"
}

export class DefaultDocumentStore implements DocumentStore {
    constructor() {
        makeObservable(this);
    }

    @observable
    private _files = new Map();

    @computed
    public get files() {
        return this._files;
    }

    @action
    public resetFilesMap() {
        this.files.set(FilesKeys.generalTermsAndConditions, {
            fileName: "OWU Bezpieczny Dom.pdf",
            fileBlob: null,
            requestStatus: new DefaultRequestStatus()
        });
        this.files.set(FilesKeys.productCard, {
            fileName: "Karta produktu.pdf",
            fileBlob: null,
            requestStatus: new DefaultRequestStatus()
        });
        this.files.set(FilesKeys.policy, {
            fileName: "Polisa.pdf",
            fileBlob: null,
            requestStatus: new DefaultRequestStatus()
        });
        this.files.set(FilesKeys.informationForm, {
            fileName: "Formularz informacyjny dotyczacy umowy ubezpieczenia.pdf",
            fileBlob: null,
            requestStatus: new DefaultRequestStatus()
        });
        this.files.set(FilesKeys.paymentForm, {
            fileName: "Druk płatności.pdf",
            fileBlob: null,
            requestStatus: new DefaultRequestStatus()
        });
    }

    @action
    public getFileBlob(fileKey: FilesKeys) {
        return this.files.get(fileKey).fileBlob;
    }

    @action
    public getFileName(fileKey: FilesKeys) {
        return this.files.get(fileKey).fileName;
    }

    @action
    public getFileRequestStatus(fileKey: FilesKeys) {
        return this.files.get(fileKey)?.requestStatus;
    }

    @action
    public savePdf(fileKey: FilesKeys, res: any, fileName?: string) {
        const file = this.files.get(fileKey);
        file.fileBlob = new Blob([res], { type: "application/pdf" });

        if (fileName) {
            file.fileName = fileName;
        }

        this.files.set(fileKey, file);
    }
}
